module.exports = "/_next/static/images/e214d11c65e516806b66a9aa147389e0-arrow.svg.webp";